
import React from 'react'
import classes from './JobOverview.module.css'
import { Playground } from './Playground/Playground'


export const PlaygroundPage: React.FC = () =>{
  return(
    <Playground />
  )
}
